import { jsx, Fragment } from "react/jsx-runtime";
import DateTime from "../../../../../external/luxon/src/datetime.js";
import "../../../../../external/luxon/src/duration.js";
import { useState, useEffect } from "react";
import { CalendarButton } from "../CalendarButton.js";
import { Scrollbar } from "../../../../Scrollbar/Scrollbar.js";
import { DATA_TEST_ID_INHERITED } from "../../../../../constants/DATA_TEST_ID_INHERITED.js";
import { inheritDataTestId } from "../../../../../utils/dataTestId.js";
const now = DateTime.now().year, hundredYears = [...Array(100)].map((_, i) => now - i), YearSelector = ({
  from,
  to,
  selected,
  onChange,
  disableYearFrom,
  disableYearTo,
  ...props
}) => {
  const [years, setYears] = useState(hundredYears);
  return useEffect(() => {
    const years2 = [];
    let fromYear = from;
    if (from < to)
      for (; fromYear <= to; )
        years2.push(fromYear++);
    else
      for (; fromYear >= to; )
        years2.push(fromYear--);
    return setYears(years2);
  }, [from, to]), useEffect(() => {
    if (selected) {
      const el = document.getElementById(`selected_${selected}`);
      el && el.scrollIntoView({ block: "nearest" });
    }
  }, [selected, years]), /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
    Scrollbar,
    {
      "data-test-id": DATA_TEST_ID_INHERITED,
      sx: style.container,
      color: "dark",
      ...props,
      children: years.map((y, i) => {
        const disabled = (disableYearTo ? disableYearTo >= y : !1) || (disableYearFrom ? disableYearFrom <= y : !1);
        return /* @__PURE__ */ jsx(
          CalendarButton,
          {
            variant: "common",
            selected: selected === y,
            id: selected === y ? `selected_${y}` : void 0,
            onClick: () => onChange(y),
            disabled,
            "data-test-id": inheritDataTestId(props, `year-button${i}`),
            children: y
          },
          y
        );
      })
    }
  ) });
}, style = {
  container: {
    display: "grid",
    gridTemplateColumns: "auto auto auto auto",
    rowGap: 6,
    paddingX: 0
  }
};
export {
  YearSelector
};
//# sourceMappingURL=YearSelector.js.map
